import {HTMLAttributes, useState} from 'react';
import {twMerge} from '../../../../common/twMerge';
import {ContentHomeTabWrapper} from '../../../../design-system/organisms/ContentHomeTabWrapper/ContentHomeTabWrapper';
import {ApiErrorBoundary} from '../../../../errors/ApiErrorBoundary.class';
import {Maybe, SortOption} from '../../../../graphql/generated/types';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {EmoticonScript} from '../../../comment/presentational/EmoticonScript';
import {ContentHomeCommentTab} from '../presentational/ContentHomeCommentTab';
import {CommentAllListContainer} from './CommentAllListContainer';

export interface ContentCommentMobileContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  seriesId: number;
}

export function ContentCommentMobileContainer({
  seriesId,
  className,
  ...props
}: ContentCommentMobileContainerProps) {
  const [selectedSortOpt, setSelectedSortOpt] = useState<Maybe<SortOption>>();
  const overview = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG)
    .data?.contentHomeOverview;

  return (
    <ContentHomeTabWrapper
      isMobile={true}
      displayAd={overview?.displayAd}
      saleState={overview?.content?.saleState}
      className={twMerge(className, 'flex flex-col space-y-8pxr')}
      {...props}
    >
      <ApiErrorBoundary>
        <ContentHomeCommentTab
          seriesId={seriesId}
          selectedSortOpt={selectedSortOpt}
          setSelectedSortOpt={setSelectedSortOpt}
          className="flex flex-1 flex-col"
        >
          <EmoticonScript />
          <CommentAllListContainer
            seriesId={seriesId}
            selectedSortOpt={selectedSortOpt}
            isContentHome={true}
          />
        </ContentHomeCommentTab>
      </ApiErrorBoundary>
    </ContentHomeTabWrapper>
  );
}
